{
    "label": "Team structure",
    "placeholder": "The team-structure editor is being built."
}
